// src/App.tsx

import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./styles/global.css";

import AppRoutes from "./routes/AppRoutes";
import SubastaOBSPage from "./pages/obs/SubastaOBSPage";

// ── Rutas públicas — evaluadas ANTES de montar BrowserRouter/Provider ────────
// window.location.pathname es síncrono → no hay ningún Navigate ni ProtectedRoute
// que pueda ejecutarse antes. Garantiza que /subasta-obs nunca vea el LoginPage.
const PUBLIC_ROUTES: Record<string, React.ReactElement> = {
  "/subasta-obs": <SubastaOBSPage />,
};

export default function App() {
  const publicPage = PUBLIC_ROUTES[window.location.pathname];
  if (publicPage) return publicPage;

  return (
    <Provider store={store}>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <AppRoutes />
      </BrowserRouter>
    </Provider>
  );
}
